import { render, staticRenderFns } from "./HcconsultaDesktop.vue?vue&type=template&id=421671b2&scoped=true"
import script from "./HcconsultaDesktop.vue?vue&type=script&lang=js"
export * from "./HcconsultaDesktop.vue?vue&type=script&lang=js"
import style0 from "./HcconsultaDesktop.vue?vue&type=style&index=0&id=421671b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421671b2",
  null
  
)

export default component.exports